import { Breakpoint } from "react-socks"
import { StaticQuery, graphql } from "gatsby"
import React from "react"

import {
  FoldSvg,
  FoldBaloon,
  IllustrationContainer,
  FoldCopy,
  FoldContainer,
} from "./styled"
import { FoldTitle, YekanParagraph } from "../typography"
//   import FoldIllustration from "../../images/fold-illustration.svg"
import FoldIllustration from "./image"
import SignUp from "../signUp"

class Fold extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      proceed: false,
    }
  }
  componentDidMount() {
    this.setState({
      proceed: true,
    })
  }
  render() {
    const { copy, description } = this.props.data.yaml.content.fold

    return (
      <FoldContainer wrap valign="center">
        <FoldCopy>
          {this.state.proceed && (
            <Breakpoint tablet up>
              <FoldBaloon>
                <FoldSvg />
              </FoldBaloon>
            </Breakpoint>
          )}
          <Breakpoint base up>
            <div className="copy-container">
              <FoldTitle
                className="title"
                dangerouslySetInnerHTML={{ __html: copy }}
              ></FoldTitle>
              <YekanParagraph
                className="description"
                dangerouslySetInnerHTML={{ __html: description }}
              ></YekanParagraph>
              <SignUp />
            </div>
          </Breakpoint>
        </FoldCopy>
        <IllustrationContainer>
          <Breakpoint tablet up>
            <FoldIllustration />
          </Breakpoint>
        </IllustrationContainer>
      </FoldContainer>
    )
  }
}

export default () => (
  <StaticQuery
    query={graphql`
      {
        yaml: contentYaml(header: { slug: { eq: "/index" } }) {
          content {
            fold {
              copy
              description
            }
          }
        }
      }
    `}
    render={data => <Fold data={data} />}
  />
)
